import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'

import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { RELOAD_DOCUMENTS_FORMALITY_MUTATION } from 'graphql/LegalFormalities'
import FormalityStepButton from './FormalityStepButton'

const FormalityReloadDocumentsBtn = () => {
  const { t } = useTranslation('legalFormalities')
  const { legalFormality, legalFormalityRefetch } = useContext(
    CurrentLegalFormalityContext
  )
  const [reloadDocumentsFormality] = useMutation(
    RELOAD_DOCUMENTS_FORMALITY_MUTATION
  )

  if (legalFormality.status !== 'document_generated') {
    return <></>
  }

  const handleReloadDocuments = () => {
    reloadDocumentsFormality({
      variables: { id: legalFormality.id },
    })
      .then(r => {
        legalFormalityRefetch()
      })
      .catch(e => {
        console.error(e)
      })
  }

  return (
    <FormalityStepButton
      title={t('show.form.submit.confirm.reloadDocuments.title')}
      description={t('show.form.submit.confirm.reloadDocuments.description')}
      buttonLabel={t('show.form.submit.confirm.reloadDocuments.label')}
      onConfirm={handleReloadDocuments}
      danger={true}
    />
  )
}

export default FormalityReloadDocumentsBtn
